import React, { Component } from "react";

import { ToastContainer } from "react-toastify";

class Notification extends Component {

    render = () => {

        return (
            <ToastContainer
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        )

    }

}

export default Notification